'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";

/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconUndo/index.tsx)
 */
export function IconUndo(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M4.35.922a.75.75 0 0 1 1.06 1.06L4.393 3H9.75a5.75 5.75 0 0 1 5.75 5.75v.5A5.75 5.75 0 0 1 9.75 15h-6a.75.75 0 0 1 0-1.5h6A4.25 4.25 0 0 0 14 9.25v-.5A4.25 4.25 0 0 0 9.75 4.5H4.393L5.41 5.518a.75.75 0 0 1-1.06 1.06L1.52 3.75z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M7.5 7.298a1 1 0 1 1-1.415 1.414L2.373 5l3.712-3.712A1 1 0 1 1 7.5 2.702L6.2 4H14a9 9 0 0 1 0 18H5a1 1 0 1 1 0-2h9a7 7 0 1 0 0-14H6.2z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}